import { AtsQuestionInput } from 'generated-graphql/types';
import { AtsJobInput } from 'pages/CandidatesRanking/types';
import { useState } from 'react';
import { KomboJobTable } from 'services/integration/components/KomboJobTable';
import { useCampaignCreationStore } from 'modules/campaign-creation/stores/useCampaignCreationStore';

// NOTE: This type is different as we can only get certain saved properties from the draft campaign
export type CampaignCreationSelectedATSJob = {
  jobDescriptionText: string;
  atsJobId: string | undefined | null;
  atsJobPostingId: string | undefined | null;
  atsQuestions: AtsQuestionInput[] | undefined | null;
};

type Props = {
  onAddJobDescription: () => void;
};

export const CampaignCreationJobDescriptionATS: React.FC<Props> = ({
  onAddJobDescription
}) => {
  const state = useCampaignCreationStore((state) => state.state);
  const onATSJobDescriptionSubmit = useCampaignCreationStore(
    (store) => store.onATSJobDescriptionSubmit
  );

  const [selectedJob, setSelectedJob] =
    useState<CampaignCreationSelectedATSJob | null>(
      state?.ATSJobDescriptionState?.selectedJob || null
    );

  const handleSelectATSJob = (jobs: AtsJobInput[]) => {
    if (jobs.length === 0) {
      setSelectedJob(null);
      return;
    }

    const job = jobs[0];

    setSelectedJob({
      jobDescriptionText: job.jobDescription,
      atsJobId: job.atsJobId,
      atsJobPostingId: job.atsJobPostingId,
      atsQuestions: job.atsQuestions
    });
  };

  const handleNextATSJob = () => {
    if (!selectedJob) return;
    onATSJobDescriptionSubmit(selectedJob);
  };

  const getIsDisabled = () => {
    return !selectedJob?.atsJobId;
  };

  return (
    <KomboJobTable
      selectableRowsSingle
      setAtsJobs={handleSelectATSJob}
      disableNext={getIsDisabled()}
      handleNext={handleNextATSJob}
      nextText="Confirm and continue"
      disableAddJobDescription={false}
      onAddJobDescription={onAddJobDescription}
    />
  );
};
